export const creatTodoList = (value) => {
    console.log("creatTodoList called with value:", value);
    return Promise.resolve();
};

export const deleteList = (taskId) => {
    console.log("deleteList called with taskId:", taskId);
    return Promise.resolve();
};

export const updateTask = (value) => {
    console.log("updateTask called with value:", value);
    return Promise.resolve();
};

export const markAllTask = (action) => {
    console.log("markAllTask called with action:", action);
    return Promise.resolve();
};
